import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  Icon,
  useToast,
  Text,
  Flex,
  Box,
  Grid,
  CircularProgress,
  CircularProgressLabel,
} from '@chakra-ui/react'
import { useEffect, useRef, useState } from 'react'
import { Button } from '../../../../../../components/Button'
import { api } from '../../../../../../services/api'
import { useMutation, useQueryClient } from 'react-query'
import { useOrcamentoPedido } from '../../../../../../contexts/OrcamentoPedidoProvider'
import { useForm, Controller, FormProvider } from 'react-hook-form'
import { IoIosSend } from 'react-icons/io'
import { format } from 'date-fns'

import ReactQuill from 'react-quill'
import 'quill-paste-smart'
import { AgendamentoRetornoCliente } from '../../Modais/AgendamentoRetornoCliente'
import { FormAgendamento } from './components/FormAgendamento'
import { useFormAgendamento } from './hooks/useFormAgendamento'
import { zodResolver } from '@hookform/resolvers/zod'
import { insertSchema } from './@schema/insertSchema'

const modules = {
  toolbar: ['bold', 'italic', 'underline'],
}

const formats = [
  'background',
  'bold',
  'color',
  'font',
  'code',
  'italic',
  'link',
  'size',
  'strike',
  'script',
  'underline',
  'blockquote',
  'header',
  'indent',
  'list',
  'align',
  'direction',
  'code-block',
  'formula',
  'image',
  'video',
]

async function enviarProposta({ numeroNota, observacao }) {
  const response = await api.post('/site/v2/orcamento-crm/envia-proposta-crm', {
    numero_nota: numeroNota,
    observacao,
  })

  return response.data
}

export function EnviarProposta24Horas() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { infoProposta, itens } = useOrcamentoPedido()
  const cancelRef = useRef()
  const formAgendamentoRef = useRef()
  const [progress, setProgress] = useState(0)

  const queryClient = useQueryClient()

  const methods = useForm({
    resolver: zodResolver(insertSchema),
  })

  const {
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = methods

  console.log('errors', errors)

  useEffect(() => {
    setValue('numero_nota', infoProposta?.num_proposta)
    setValue('codigo_parceiro', infoProposta?.cliente?.codigo_parceiro)
    setValue('codigo_contato', infoProposta?.codigo_contato)
    setValue('numero_pedido', infoProposta?.numero_pedido)
  }, [setValue, infoProposta?.num_proposta, infoProposta])

  const formAgendamento = useFormAgendamento({
    numeroNota: infoProposta?.num_proposta,
    infoProposta,
    optionsQuery: {
      onSuccess: () => {
        queryClient.invalidateQueries('agendamento-retorno')

        toast({
          title: 'Agendamento realizado com sucesso',
          status: 'success',
        })
        onClose()
      },
      onError: (error) => {
        toast({
          title: 'Erro ao realizar agendamento',
          description: error.response.data.erros,
          status: 'error',
        })
      },
    },
  })

  const { agendarRetorno, isLoadingAgendamento } = formAgendamento

  const toast = useToast({
    position: 'top-right',
    duration: 5000,
    isClosable: true,
  })
  const { mutateAsync: handleEnviarProposta, isLoading: isLoadingProposta } = useMutation({
    mutationFn: enviarProposta,
    onSuccess: (data) => {
      toast({
        title: 'Proposta enviada com sucesso',
        status: 'success',
      })

      queryClient.setQueryData(['items', infoProposta.num_proposta], (oldData) => {
        return {
          ...oldData,
          informacao_da_proposta: {
            ...oldData.informacao_da_proposta,
            cliente: {
              ...oldData.informacao_da_proposta.cliente,
              data_retorno: format(new Date(data.data_retorno), 'dd/MM/yyyy'),
            },
            id_funil: data.id_funil,
          },
        }
      })

      // onClose()
    },
    onError: (error) => {
      toast({
        title: 'Erro ao enviar proposta',
        description: error.response.data.erros,
        status: 'error',
      })
    },
  })

  useEffect(() => {
    let interval
    if (isLoadingProposta || isLoadingAgendamento) {
      setProgress(0)
      interval = setInterval(() => {
        setProgress((prev) => (prev + 10 > 100 ? 0 : prev + 10))
      }, 500)
    }
    return () => clearInterval(interval)
  }, [isLoadingProposta, isLoadingAgendamento])

  async function onSubmit(data) {
    const { motivo } = data
    const formAgendamentoData = formAgendamentoRef.current
    const hasItemTravado = itens.some((item) => item.trava_item)

    if (hasItemTravado) {
      toast({
        title: 'Não foi possivel enviar a proposta',
        description: 'Existem itens que precisam ser editados, por favor, verifique os itens.',
        status: 'error',
      })
      return
    }

    await handleEnviarProposta({
      numeroNota: infoProposta.num_proposta,
      observacao: `Olá ${infoProposta?.nome_contato},

                  Conforme solicitado, segue anexo nossa proposta comercial.

                  ${motivo ? motivo : ''}

                  Qualquer dúvida, estou à sua inteira disposição.
                  `,
    })

    const params = {
      ...data,
      assunto_email: data.assunto_email
        ? `Proposta de Fornecimento: ${infoProposta?.numero_pedido} - Innovation Brindes ${data.assunto_email}`
        : `Proposta de Fornecimento: ${infoProposta?.numero_pedido} - Innovation Brindes`,
      numero_nota: infoProposta.num_proposta,
      codigo_parceiro: infoProposta?.cliente?.codigo_parceiro,
      codigo_contato: infoProposta?.codigo_contato,
      numero_pedido: infoProposta?.numero_pedido,
      data_agendamento: `${data.dataRetorno} ${data.horaRetorno}`,
      observacoes: data.observacoes,
      conteudo_retorno: data.mensagem,
      enviar_proposta: true,
      tipo_agendamento: data.agendamentoRetorno ? data.agendamentoRetorno : 'EMAIL',
    }

    console.log('params', params)

    await agendarRetorno(params)

    // onClose()
  }

  return (
    <>
      <Button
        onClick={onOpen}
        border={0}
        borderRadius={0}
        disabled={infoProposta?.valida_proposta_nova}
        bgColor="transparent"
        px={3}
        py={2}
        color="#2D2D2D"
        _hover={{
          bg: '#e2e2e2',
        }}
        fontWeight="normal"
        leftIcon={<Icon as={IoIosSend} fontSize="20px" color="#378BBF" />}
      >
        Enviar Proposta
      </Button>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        size="full"
        closeOnEsc={!(isLoadingProposta || isLoadingAgendamento)}
        closeOnOverlayClick={!(isLoadingProposta || isLoadingAgendamento)}
      >
        <AlertDialogOverlay>
          <AlertDialogContent position="relative">
            <FormProvider {...methods}>
              {(isLoadingProposta || isLoadingAgendamento) && (
                <Flex
                  position="absolute"
                  top={0}
                  left={0}
                  right={0}
                  bottom={0}
                  bg="rgba(255, 255, 255, 0.8)"
                  zIndex={9999}
                  justify="center"
                  align="center"
                  flexDir="column"
                >
                  <CircularProgress value={progress} size="120px" color="blue.400" thickness="4px">
                    <CircularProgressLabel>{progress}%</CircularProgressLabel>
                  </CircularProgress>
                  <Text mt={4} fontSize="lg">
                    Enviando proposta e agendamento...
                  </Text>
                </Flex>
              )}
              <AlertDialogBody>
                <Grid gridTemplateColumns={['1fr', '1fr 1fr']} gap={4}>
                  <Box>
                    <Text bgColor="#378BBF" py="18px" w="full" textAlign="center" color="white" fontSize="17px" textTransform="uppercase">
                      ENVIO DE PROPOSTA
                    </Text>{' '}
                    <Text bg="#F5F5F5" pl={4} py={5} border="1px solid #E2E8F0">
                      Olá <strong>{infoProposta?.nome_contato}</strong>, <br /> <br />
                      Conforme solicitado, <strong>segue anexo nossa proposta comercial.</strong>
                    </Text>
                    <Controller
                      control={control}
                      defaultValue=""
                      // rules={{ required: 'Campo obrigatório' }}
                      name="motivo"
                      render={({ field }) => (
                        <ReactQuill theme="snow" {...field} style={{ height: '200px', marginBottom: '42px' }} modules={modules} formats={formats} />
                      )}
                    />
                    <Flex border="1px solid #E2E8F0" bg="#F5F5F5" py={2} px={2}>
                      <Text fontSize="14px" ml={2}>
                        Qualquer dúvida, estou à sua inteira disposição.
                      </Text>
                    </Flex>
                  </Box>

                  <Flex flexDir={'column'} justifyContent="space-between">
                    <Text bgColor="#378BBF" py="18px" w="full" textAlign="center" color="white" fontSize="17px" textTransform="uppercase" mb={4}>
                      AGENDAMENTO DE RETORNO
                    </Text>
                    <FormAgendamento />

                    <Box w="full" mt={2}>
                      <Button
                        isLoading={isLoadingProposta || isLoadingAgendamento}
                        w="100%"
                        borderRadius="6px"
                        bgColor="#378BBF"
                        fontSize="15px"
                        onClick={handleSubmit(onSubmit)}
                      >
                        Enviar Proposta e Adicionar Agendamento
                      </Button>
                    </Box>
                  </Flex>
                </Grid>
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button ref={cancelRef} onClick={onClose}>
                  Voltar
                </Button>
              </AlertDialogFooter>
            </FormProvider>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
